// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Subject } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  OnDestroy,
  inject,
} from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { APICallGateComponent } from '../../../shared/components/api-call-gate.component';
import {
  AT_MYCORO_MATERIAL_NUMBERS,
  AT_NEOCOR_MATERIAL_NUMBERS,
  MI_MODALITY_IDS,
} from '../../../shared/utils/modalityHelpers';
import { SystemOverviewService } from '../../services/systemOverview.service';
import { OverviewComponent } from '../component-overview/overview.component';
import { MIApplications } from '../mi-applications/mi-applications.component';
import { ATNeocorApplicationsComponent } from '../at-neocor-applications/at-neocor-applications.component';

@Component({
  selector: 'app-component-overview-switch',
  templateUrl: './overview-switch.component.html',
  standalone: true,

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    APICallGateComponent,
    OverviewComponent,
    MIApplications,
    AsyncPipe,
    ATNeocorApplicationsComponent,
  ],
})
export class OverviewSwitchComponent implements OnDestroy {
  private systemOverviewService = inject(SystemOverviewService);
  private destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // data sources, expects request to be kicked off already!!
  systemDetails = this.systemOverviewService.systemDetails;
  systemDetails$ = this.systemDetails.lastSuccessfulData$.pipe();
  modalityId$ = this.systemDetails$.pipe(
    map(({ modalityId }) => {
      return modalityId;
    }),
  );
  systemMaterialNumber$ = this.systemDetails$.pipe(
    map(({ systemMaterialNumber }) => {
      return systemMaterialNumber;
    }),
  );

  isMI$ = this.modalityId$.pipe(
    map((id) => MI_MODALITY_IDS.indexOf(id) !== -1),
  );

  isAtNeoCor$ = this.systemMaterialNumber$.pipe(
    map(
      (materialNumber) =>
        AT_NEOCOR_MATERIAL_NUMBERS.indexOf(materialNumber) !== -1,
    ),
  );

  isMyCoro$ = this.systemMaterialNumber$.pipe(
    map(
      (materialNumber) =>
        AT_MYCORO_MATERIAL_NUMBERS.indexOf(materialNumber) !== -1,
    ),
  );

  isDefault$ = combineLatest([this.isMI$, this.isAtNeoCor$, this.isMyCoro$]).pipe(
    map(
      ([isMI, isAtNeoCor, isMyCoro]) =>
        isMI === false && isAtNeoCor === false && isMyCoro === false,
    ),
  );
}
